module.exports = __webpack_public_path__ + "img/light-switch-sm.40acef45.svg";